import { EnumPaymentMethods } from '../stores/payredeem/types';

export const DOCUMENT_TITLE = 'CrownCoinsCasino';
export const DOCUMENT_TITLE_WITH_SEP = 'CrownCoinsCasino | ';

export const SOCKET_USER_CONNECT_EVENT = 'connect';
export const SOCKET_USER_LOGIN_EVENT = 'login';
export const SOCKET_USER_TRANSACTION = 'USER_TRANSACTION';
export const SOCKET_USER_TRANSACTION_REDEEM = 'USER_TRANSACTION_REDEEM';
export const SOCKET_ACCOUNT_CAPTURE = 'ACCOUNT_CAPTURE';
export const SOCKET_USER_WALLET_BALANCE = 'USER_WALLET_BALANCE';
export const SOCKET_SEND_USER_MESSAGE = 'SEND_USER_MESSAGE';
export const SOCKET_USER_LOYALTY_UPDATE = 'USER_LOYALTY_UPDATE';
export const SOCKET_DISCONNECT_MULTISESSION_USER = 'DISCONNECT_USER_MULTISESSION';
export const SOCKET_USER_EVENT_TRIGGER = 'USER_EVENT_TRIGGER';
export const SOCKET_EVENT_STARTED = 'EVENT_STARTED';
export const SOCKET_CLAIM_PACKAGE_COMPLETED = 'CLAIM_PACKAGE_COMPLETED';
export const SOCKET_TOURNAMENT_UPDATE = 'TOURNAMENT_UPDATE';
export const SOCKET_USER_QUEST_MILESTONE_COMPLETED = 'USER_QUEST_MILESTONE_COMPLETED';
export const SOCKET_REFERRAL_BONUS_CREATED = 'REFERRAL_BONUS_CREATED';
export const SOCKET_JACKPOT_UPDATED = 'JACKPOT_UPDATED';
export const SOCKET_METAGAME_RESULT = 'METAGAME_RESULT';
export const SOCKET_METAGAME_TERMINATED = 'METAGAME_TERMINATED';

export const LOW_BALANCE = 'LOW_BALANCE';
export const BALANCE_THRESHOLD_WARNING = 'BALANCE_THRESHOLD_WARNING';

export const SOCKET_POC_PUSHED = 'POC_PUSHED';

export const SOCKET_POC_FAILED = 'POC_FAILED';

export const SOCKET_POC_SUCCESS = 'POC_SUCCESS';

export const SOCKET_KYC_FORCED = 'FORCE_KYC';

export const COIN_SWITCH_DELAY = 65;
export const GAME_SWITCH_DELAY = 0;

export const HOME_CATEGORY_NAME_KEY = 'common.all';

export const ANALYTICS_TRACKING_EVENT_DELAY = 100;

export const SIGNUP_ERROR_TEXT = 'Failed to sign up with provided credentials.';
export const LOGIN_ERROR_TEXT = 'This email/password is incorrect.';
export const BACKEND_ERROR_TEXT = 'Something went wrong. Please try again later.';

export const FIREBASE_ERRORS_TEXTS: Record<string, string> = {
  'auth/email-already-in-use': 'auth.firebaseErrors.emailAlreadyInUse',
  'auth/wrong-password': 'auth.firebaseErrors.wrongPassword',
  'auth/user-not-found': 'auth.firebaseErrors.userNotFound',
  'auth/invalid-email': 'auth.firebaseErrors.invalidEmail',
  'auth/account-exists-with-different-credential': 'auth.firebaseErrors.accountExistsWithDifferentCredential',
  'auth/invalid-phone-number': 'auth.firebaseErrors.invalidPhoneNumber',
  'auth/too-many-requests': 'auth.firebaseErrors.tooManyRequests',
} as const;

export const LAST_DAY_NUMBER = 7;

export const GAME_PAGINATION_LIMIT = 20;

export const PRAGMATIC_DOMAIN_DEV = 'https://xlr-spe1.prerelease-spe.biz';
export const PRAGMATIC_DOMAIN_PROD = 'https://xlr.ppgames.net';

export const PLAYTECH_DOMAIN_DEV = new RegExp(/(.*).ptstaging.eu/);
export const PLAYTECH_DOMAIN_PROD = new RegExp(/(.*).onegameslink.com/);

export const DEFAULT_LOW_BALANCE_OFFER_TIMER = 240; // seconds
export const SUPPORT_EMAIL = 'support@crowncoinscasino.com';
export const CONTACT_SUPPORT_URL = 'https://help.crowncoinscasino.com';

export const MIN_RECOMMENDED_GAMES_TO_SHOW = 3;

export const USER_EXCEEDED_REGISTRATION_LIMITATION_ERROR = 'UserRegistrationLimitError';
export const INCORRECT_CREDENTIAL = 'INCORRECT_CREDENTIAL';
export const ACCESS_DENIED_ERROR = 'AccessDenied';
export const INACTIVE_ENTITY_ERROR = 'IN_ACTIVE_ENTITY';
export const USER_INACTIVE_ERORR = 'UserInActive';

export const GAME_LAUNCH_TRIGGER = 'GAME_LAUNCH_TRIGGER';

export const CURRENT_PAYMENT_APP_VERSION = 4;
export const CURRENT_PAYMENTS_PROJECT_URL = '/securepay';
export const DEFAULT_PAYMENT_METHODS: {
  hide: boolean;
  disabled: boolean;
  type: EnumPaymentMethods;
  supporting_recurring: boolean;
}[] = [
  {
    hide: false,
    disabled: false,
    type: EnumPaymentMethods.APPLE_PAY,
    supporting_recurring: true,
  },
  {
    hide: false,
    disabled: false,
    type: EnumPaymentMethods.applePay,
    supporting_recurring: true,
  },
  {
    hide: false,
    disabled: false,
    type: EnumPaymentMethods.card,
    supporting_recurring: true,
  },
  {
    hide: false,
    disabled: false,
    type: EnumPaymentMethods.skrill,
    supporting_recurring: false,
  },
];

export const PRIMARY_HTML_ELEMENT_ID = 'mainHtmlId';

export const DESKTOP_THRESHOLD = 768;

export const BINGO_LAST_ACKNOWLEDGED_EVENT_KEY = 'bingo-last-acknowledged-event-id';
